import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { INTERNAL_LINKS } from "../../../enum";
import { useCertificateStore } from "../../../store/certificate";

export default function ProgramCards({ userProfile,faculty=false, program: { title, id, image, slug, startDate = false }, linkTo, isDashboard}) {

  const certificateStore = useCertificateStore()

  function onClick() {
    certificateStore.setCurrentCertificate({ title })
  }

  return (
    <>
      <div className="container-card-certificate">
        <div className="container-image">
          <img src={image} alt="container-situation" />
        </div>
        <div className="container-content">
          <p
            style={{
              color: "black",
              fontSize: "24px",
              margin: "0px",
              padding: "0px",
              marginBottom: "5px",
              textAlign: "center",
            }}
          >
            {title}
          </p>
          {!isDashboard && (
            <p
              style={{
                color: "black",
                fontSize: "14px",
                margin: "0px",
                padding: "0px",
              }}
            >
              Start Date: {moment.utc(startDate).format("MMM DD")},{" "}
              {moment.utc(startDate).format("YYYY")}
            </p>
          )}
          <Link to={linkTo} onClick={onClick}>
            <div
              style={faculty ? { background: 'rgb(0, 181, 116)'} : { background: "#fe5621" }}
              className="button-card-certificate"
            >
              {faculty ? 'Dashboard' : 'Explore More'}
            </div>
          </Link>

        </div>
      </div>
    </>
  );
}